<template>
    <div v-if="options.length" class="sort-order-dropdown inline-flex flex-row items-center">
        <span
            v-if="options.length === 1"
            class="sort-order-dropdown__locked-label text-sm text-grey-2 px-2 py-1"
            data-cy="sortOrderLockedLabel"
        >
            Sort: {{ options[0].label }}
        </span>
        <el-select
            v-else
            :value="value"
            class="sort-order-dropdown__select filter-dropdown ml-2"
            data-cy="sortOrderSelect"
            @change="onSortChange"
        >
            <el-option
                v-for="option in options"
                :key="option.value"
                :label="option.label"
                :value="option.value"
            />
        </el-select>
    </div>
</template>

<script>
const LABELS = {
    default: 'Default',
    head_start: 'Head Start',
    gp_surveyor: 'GP Surveyor',
    co_surveyor: 'Co-Surveyor',
}

export default {
    name: 'SortOrderDropdown',
    props: {
        value: {
            type: String,
            default: 'default',
        },
        allowedOrders: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        options() {
            return this.allowedOrders.map(key => ({
                value: key,
                label: LABELS[key] || key,
            }))
        },
    },
    methods: {
        onSortChange(newValue) {
            this.$emit('input', newValue)
        },
    },
}
</script>
